module.exports = __webpack_public_path__ + "img/part-4-title.3f5ad303.png";